import { useEffect, useRef } from 'react';

export const usePolling = (
    callback: () => void | Promise<void>,
    interval: number,
    immediate = false,
) => {
    const savedCallback = useRef(callback);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        if (immediate) {
            savedCallback.current();
        }

        const intervalId = setInterval(() => {
            savedCallback.current();
        }, interval);

        return () => clearInterval(intervalId);
    }, [interval, immediate]);
};
